import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-lg shadow-sm' : 'bg-gradient-to-b from-black/40 to-transparent backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-32">
          {/* Logo - Mit maximaler Breite für Mobile */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://customer-assets.emergentagent.com/job_b449bff2-a271-4cbe-9cad-1f6cd5dbd33a/artifacts/y4otwih5_20251110%20tl%20charity%20design%20%26%20identity%20V01-02.png"
              alt="TL Charity Logo"
              className="h-20 w-auto md:h-24 lg:h-28 max-w-[120px] md:max-w-[150px] lg:max-w-none"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('mission')}
              className={`font-medium transition-colors duration-300 ${
                isScrolled ? 'text-gray-700 hover:text-[#FF1B8D]' : 'text-white hover:text-[#FF9B8C] drop-shadow-lg'
              }`}
            >
              Mission
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className={`font-medium transition-colors duration-300 ${
                isScrolled ? 'text-gray-700 hover:text-[#FF1B8D]' : 'text-white hover:text-[#FF9B8C] drop-shadow-lg'
              }`}
            >
              So funktioniert's
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className={`font-medium transition-colors duration-300 ${
                isScrolled ? 'text-gray-700 hover:text-[#FF1B8D]' : 'text-white hover:text-[#FF9B8C] drop-shadow-lg'
              }`}
            >
              Projekte
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors duration-300 ${
                isScrolled ? 'text-gray-700 hover:text-[#FF1B8D]' : 'text-white hover:text-[#FF9B8C] drop-shadow-lg'
              }`}
            >
              Kontakt
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FF1B8D] hover:bg-[#E01679] text-white px-6 py-2 rounded-full font-semibold shadow-lg hover:shadow-xl"
            >
              Jetzt kontaktieren
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 hover:text-[#FF1B8D] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4 animate-fadeIn">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('mission')}
                className="text-gray-700 hover:text-[#FF1B8D] font-medium transition-colors duration-300 text-left px-4"
              >
                Mission
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-gray-700 hover:text-[#FF1B8D] font-medium transition-colors duration-300 text-left px-4"
              >
                So funktioniert's
              </button>
              <button
                onClick={() => scrollToSection('projects')}
                className="text-gray-700 hover:text-[#FF1B8D] font-medium transition-colors duration-300 text-left px-4"
              >
                Projekte
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-[#FF1B8D] font-medium transition-colors duration-300 text-left px-4"
              >
                Kontakt
              </button>
              <div className="px-4 pt-2">
                <Button
                  onClick={() => {
                    scrollToSection('contact');
                    setIsMobileMenuOpen(false);
                  }}
                  className="w-full bg-[#FF1B8D] hover:bg-[#E01679] text-white py-2 rounded-full font-semibold"
                >
                  Jetzt kontaktieren
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
